import React from 'react'

const HorizontalSeparator = () => {
  return (
    <div className="rounded-sm bg-gray-300 my-2 h-0.5">
    </div>
  )
}

export default HorizontalSeparator